import React, { createContext, useContext } from 'react';
import useTutorial from '../hooks/useTutorial';

const TutorialContext = createContext();

export const TutorialProvider = ({ children, onTutorialComplete }) => {
  const tutorialState = useTutorial(onTutorialComplete);

  return (
    <TutorialContext.Provider value={tutorialState}>
      {children}
    </TutorialContext.Provider>
  );
};

export const useTutorialContext = () => {
  const context = useContext(TutorialContext);
  if (!context) {
    throw new Error('useTutorialContext must be used within a TutorialProvider');
  }
  return context;
};

export default TutorialContext;